import { assign } from 'lodash'
import { parseErrors } from 'lib/api-utils'
import { SYSTEM_ERROR_MESSAGE } from 'shared/constants'
import fetch from '../lib/fetch'
import * as urls from '../lib/urls'

export const createCashFund = (data, createBankAccount) => {
  return new Promise((resolve, reject) => {
    const cashFund = {
      fund_goal_amt: data.goalAmt
        ? data.goalAmt.toString().replace(',', '')
        : null,
      fund_image_url: data.imageUrl,
      fund_name: data.fundName,
      fund_notes: data.notes,
      product_id: data.productId,
    }

    if (createBankAccount) {
      assign(cashFund, {
        account_last_4: data.bank_account.last4,
        account_token: data.id,
        bank_name: data.bank_account.bank_name,
        city: data.address.city,
        client_ip: data.client_ip,
        dob_day: data.dobDay,
        dob_month: data.dobMonth,
        dob_year: data.dobYear,
        first_name: data.firstName,
        last_name: data.lastName,
        line_1: data.address.streetAddress1,
        line_2: data.address.streetAddress2,
        phone_number: data.address.phoneNumber,
        postal_code: data.address.zip,
        state: data.address.state,
      })
    }

    fetch(urls.apiV3CashFundsPath, {
      body: JSON.stringify({ cash_fund: cashFund }),
      inflectKeys: false,
      method: 'POST',
    })
      .then((response) => {
        resolve()
      })
      .catch((response) => {
        let error = SYSTEM_ERROR_MESSAGE
        if (response.error && response.error.message) {
          error = response.error.message
        } else {
          const parsedErrors = parseErrors(response)
          if (parsedErrors._error) {
            error = parsedErrors._error
          }
        }
        reject(new Error({ general: error }))
      })
  })
}
